import { uploadToCloudinary } from "./uploadToCloudinary";

function shouldUseCloudinaryFallback(err) {
  const msg = String(err?.message || err || "").toLowerCase();
  return msg.includes("generateuploadurl is disabled in development");
}

export const uploadToGCS = async (file, generateUploadUrl) => {
  const contentType = file?.type || "application/octet-stream";
  const filename = `uploads/${Date.now()}-${file?.name || "file"}`;

  let signedUrl = "";
  try {
    const { data, errors } = await generateUploadUrl({
      variables: { filename, contentType },
    });

    if (errors?.length) {
      throw new Error(errors[0]?.message || "Failed to generate upload URL.");
    }

    signedUrl = data?.generateUploadUrl;
    if (!signedUrl) {
      throw new Error("Missing signed upload URL.");
    }
  } catch (err) {
    if (shouldUseCloudinaryFallback(err)) {
      return uploadToCloudinary(file);
    }
    throw err;
  }

  const uploadResponse = await fetch(signedUrl, {
    method: "PUT",
    headers: { "Content-Type": contentType },
    body: file,
  });

  if (!uploadResponse.ok) {
    const errorText = await uploadResponse.text();
    throw new Error(
      `Upload failed with status ${uploadResponse.status}: ${uploadResponse.statusText}. ${errorText || ""}`
    );
  }

  return `https://storage.googleapis.com/${process.env.REACT_APP_GCLOUD_BUCKET_NAME}/${filename}`;
};

